import { memo } from 'react';

import { ClipSource } from '@air/api/types';
import { ImportIcon } from '@air/design-icons';

import BoardThumbnail from '~/components/BoardThumbnail/BoardThumbnail';
import { ImportItemIcon } from '~/components/Import/ImportItemIcon';
import { type WorkspaceImportRow } from '~/components/v2/components/workspace/workspace-imports/workspaceImportTypes';

const IMPORT_SOURCES_WITH_LOGO = new Set<WorkspaceImportRow['source']>([
  ClipSource.box,
  ClipSource.brandfolder,
  ClipSource.canto,
  ClipSource.dropbox,
  ClipSource.frameio,
  ClipSource.googleDrive,
  ClipSource.sharePoint,
]);

export type WorkspaceImportsListItemThumbnailProps = {
  row: Pick<WorkspaceImportRow, 'board' | 'source' | 'thumbnailUrl'>;
};

export const WorkspaceImportsListItemThumbnail = memo(({ row }: WorkspaceImportsListItemThumbnailProps) => {
  if (row.thumbnailUrl) {
    return (
      <BoardThumbnail
        board={{ thumbnails: [row.thumbnailUrl], title: row.board.title }}
        className="relative mr-3 inline-block size-10 shrink-0 rounded-4 object-cover ads:ring-ads-gray-1 ring-2 ring-gray-1"
        height={40}
        sizes="40px"
        width={40}
      />
    );
  }

  return (
    <span
      className="relative mr-3 flex size-10 shrink-0 items-center justify-center rounded-4 ads:bg-subtle bg-gray-3 ads:ring-ads-gray-1 ring-2 ring-gray-1"
      data-testid="WORKSPACE_IMPORTS_ITEM_THUMBNAIL"
    >
      {IMPORT_SOURCES_WITH_LOGO.has(row.source) ? (
        <ImportItemIcon className="mr-0 size-6" source={row.source} />
      ) : (
        <ImportIcon aria-hidden className="ads:text-icon-subtle text-gray-9" size="sm" />
      )}
    </span>
  );
});

WorkspaceImportsListItemThumbnail.displayName = 'WorkspaceImportsListItemThumbnail';
